import { render, staticRenderFns } from "./TabRequesting.vue?vue&type=template&id=10eeabe6&scoped=true&"
import script from "./TabRequesting.vue?vue&type=script&lang=js&"
export * from "./TabRequesting.vue?vue&type=script&lang=js&"
import style0 from "./TabRequesting.vue?vue&type=style&index=0&id=10eeabe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eeabe6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
